document.addEventListener('DOMContentLoaded', () => {
  const localizationForms = document.querySelectorAll('form[id^="localization-"]');

  localizationForms.forEach((form) => {
    const formId = form.id;

    // Add event listeners to all language options to set country code
    form.querySelectorAll('[data-disclosure-option][data-country-code]').forEach((option) => {
      option.addEventListener('click', (e) => {
        e.preventDefault();

        const countryCode = option.getAttribute('data-country-code');
        const localeCode = option.getAttribute('data-value');
        const baseUrl = option.getAttribute('data-base-url');
        const localePath = option.getAttribute('data-locale-path');
        const currentPath = option.getAttribute('data-current-path');

        // If we have a base URL, use direct navigation instead of form submission
        if (baseUrl) {
          let url = baseUrl;
          if (localePath) {
            url += localePath;
          }

          // Add current path, but handle potential duplicates
          if (currentPath) {
            const cleanPath = currentPath.replace(/^\/(fr|nl)\//, '/'); // Remove locale prefixes if present
            url += cleanPath.startsWith('/') ? cleanPath : `/${cleanPath}`;
          }

          // Clean up any double slashes (except after protocol)
          url = url.replace(/([^:]\/)\/+/g, '$1');
          window.location.href = url;
          return;
        }

        // Otherwise use standard form submission
        document.getElementById(`CountrySelector-${formId}`).value = countryCode;
        document.getElementById(`LocaleSelector-${formId}`).value = localeCode;

        // Submit the form
        option.closest('form').submit();
      });
    });

    // Add event listeners for direct URL navigation (when locale isn't available)
    form.querySelectorAll('[data-disclosure-direct]').forEach((option) => {
      option.addEventListener('click', (e) => {
        e.preventDefault();

        let directUrl = option.getAttribute('data-direct-url');
        if (directUrl) {
          // Clean url by removing locale prefixes and fixing double slashes
          directUrl = directUrl.replace(/([^:]\/)\/+/g, '$1');
          directUrl = directUrl.replace(/\/fr\/|\/nl\//g, '/');
          directUrl = directUrl.replace(/([^:]\/)\/+/g, '$1');
          window.location.href = directUrl;
        }
      });
    });
  });
});
